/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTokenResponseDtoSchema = z.object({
  token: z.string().nullish(),
  success: z.optional(z.boolean()),
});
